import i18n from 'i18n-js';
import { formatSinceTime } from './dateTime';
import { navigate } from './navigation';

export const ROLES = Object.freeze({
  ADMINISTRATOR: 'Administrator',
  MANAGER: 'Manager',
  OPERATOR: 'Operator',
} as const);

export const ROLE_ITEMS = Object.values(ROLES).map((value) => ({ name: value, value }));

export const settingsLine = [
  { flag: '', value: 'Account' },
  {
    flag: 'settings-users',
    value: 'Users',
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER],
    onClick: (navigate: (name: string, params?: Record<string, unknown>) => void) => navigate('Settings', { screen: 'Users' }),
  },
  { flag: '', value: 'Devices', onClick: (navigate) => navigate('Settings', { screen: 'Devices' }) },
  {
    flag: '',
    value: 'Machines',
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER],
    onClick: (navigate: (name: string, params?: Record<string, unknown>) => void) =>
      navigate('Settings', { screen: 'Machines', params: { screen: 'MachinesScreen', params: { screen: 'MachinesList' } } }),
  },
  { flag: '', value: 'Notifications', onClick: (navigate) => navigate('Settings', { screen: 'Notifications' }) },
  {
    flag: 'settings-connector',
    value: 'Connector',
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER],
    onClick: () => navigate('Settings', { screen: 'Connector' }),
  },
  {
    flag: '',
    value: 'API Keys',
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER],
    onClick: (navigate: (name: string, params?: Record<string, unknown>) => void) => navigate('Settings', { screen: 'APIKeys' }),
  },
  {
    flag: '',
    value: 'Imnoo',
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER],
    onClick: (navigate: (name: string, params?: Record<string, unknown>) => void) => navigate('Settings', { screen: 'Imnoo' }),
  },
  {
    flag: 'settings-powerbi',
    value: 'Power BI',
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER],
    onClick: (navigate: (name: string, params?: Record<string, unknown>) => void) => navigate('Settings', { screen: 'PowerBI' }),
  },
  {
    flag: 'settings-administration',
    value: 'Company',
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER],
    onClick: (navigate: (name: string, params?: Record<string, unknown>) => void) => navigate('Settings', { screen: 'Company' }),
  },
  { flag: '', value: 'Support', onClick: (navigate) => navigate('Settings', { screen: 'Support' }) },
];

export const formatUser = (u: Record<string, unknown>) => {
  const { userProfile = {} as Record<string, unknown>, emailAddress, role, lastUsedOn, invitedOn } = u;

  return {
    name: `${(userProfile as Record<string, unknown>).firstName} ${(userProfile as Record<string, unknown>).lastName}`,
    email: emailAddress,
    id: (userProfile as Record<string, unknown>).userId || emailAddress,
    role: i18n.t(role as string),
    lastUsedOn: lastUsedOn ? formatSinceTime(lastUsedOn as string) : '',
    invitedOn: invitedOn ? formatSinceTime(invitedOn as string) : '',
  };
};
